import React from "react";
import EntityForm from "modules/entity/forms";
import Form from "./form";
import useTranslation from "../../../hooks/useTranslation";

const Create = ({ showCreateModal }) => {
  const { tr } = useTranslation();

  return (
    <EntityForm.Main
      method="post"
      entity="storages"
      name="all"
      url="/storages"
      appendData={true}
      normalizeData={(data) => data}
      onSuccess={(data, resetForm) => {
        resetForm();
        showCreateModal(false);
      }}
      fields={[
        {
          name: "organization_id",
          value: 0,
        },
        {
          name: "name",
          required: true,
        },
        {
          name: "status",
          value: true,
          onSubmitValue: (value) => (value ? 1 : 0),
        },
      ]}
    >
      {({ isSubmitting, values, setFieldValue }) => {
        return (
          <div>
            <div className="modal-title">{tr("Добавить склад")}</div>
            <div className="modal-body">
              <Form {...{ isSubmitting, values, setFieldValue }} />
            </div>
          </div>
        );
      }}
    </EntityForm.Main>
  );
};

export default Create;
